interface ConfirmDialogState {
  open: boolean;
  title: string;
  message: string;
  onConfirm: (() => void) | null;
}

interface ConfirmDialogProps extends ConfirmDialogState {
  onCancel: () => void;
}

export function ConfirmDialog({ open, title, message, onConfirm, onCancel }: ConfirmDialogProps) {
  if (!open) return null;
  return (
    <div className="fixed inset-0 z-[70] flex items-center justify-center bg-black/30 backdrop-blur-sm">
      <div className="w-[360px] rounded-2xl bg-white p-6 shadow-2xl">
        <h3 className="mb-2 text-sm font-semibold text-slate-900">{title}</h3>
        <p className="mb-4 text-sm text-slate-500">{message}</p>
        <div className="flex justify-end gap-2">
          <button
            type="button"
            onClick={onCancel}
            className="rounded-lg px-3 py-1.5 text-sm text-slate-600 hover:bg-slate-100"
          >
            取消
          </button>
          <button
            type="button"
            onClick={() => onConfirm?.()}
            className="rounded-lg bg-red-500 px-3 py-1.5 text-sm font-medium text-white hover:bg-red-600"
          >
            确定
          </button>
        </div>
      </div>
    </div>
  );
}

export type { ConfirmDialogState };